<template>
  <div class="flex">
    <Sidebar />
    <router-view></router-view>
  </div>
</template>

<script>
import Sidebar from "../components/common/SidebarComponent.vue";
export default {
  components: {
    Sidebar,
  },
  setup() {},
};
</script>
